function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_examine");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u65B0\\u5A92\\u4F53\\u5BA1\\u6838",
  transform: "translate(-32.000000, -155.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u4FA7\\u8FB9\\u680F",
  transform: "translate(0.000000, 60.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-4",
  transform: "translate(0.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  transform: "translate(32.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon_examine",
  fillRule: "nonzero",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.33323333,15 L3.33515417,11.6844167 C3.33552917,11.4544167 3.5220375,11.268 3.7520625,11.26775 C5.14120833,11.26775 6.530375,11.26775 7.91954167,11.26775 C8.3035,11.26775 8.30145833,10.9271667 8.30145833,10.1163333 C8.30145833,9.3055 6.259125,8.62254167 6.259125,5.772 C6.259125,2.9214625 8.374875,2.08333333 10.13325,2.08333333 C11.891625,2.08333333 13.8068333,2.9214625 13.8068333,5.772 C13.8068333,8.62254167 11.7752083,9.07575 11.7752083,10.1163333 C11.7752083,11.156875 11.7752083,11.26775 12.1004583,11.26775 C13.483625,11.26775 14.8668333,11.26775 16.2500417,11.26775 C16.480125,11.26775 16.6667083,11.4543333 16.6667083,11.6844167 L16.6667083,15 L3.33323333,15 Z",
  id: "\\u8DEF\\u5F84",
  stroke: "#666666",
  strokeWidth: 1.25,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.33333333,
  y1: 17.5,
  x2: 16.6666667,
  y2: 17.5,
  id: "\\u8DEF\\u5F84",
  stroke: "#666666",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))));

var SvgContentReview = function SvgContentReview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContentReview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/content_review.08970092.svg";
export { ForwardRef as ReactComponent };